<template>
  <Header />

  <div class="section container">
    <div class="content">
      <div class="heading">
        <h1>Verify Your Information</h1>
      </div>

      <CustomerContact
        :first-name="customer.first_name"
        :last-name="customer.last_name"
        :instagram-handle="customer.instagram_handle"
        :phone="customer.phone"
        :address1="customer.address1"
        :address2="customer.address2"
        :city="customer.city"
        :province="customer.province"
        :zip="customer.zip"
        :country="customer.country"
        :notification-preference="customer.notification_preference"

        button-text="Next"
        @contactFormSubmitted="verifyCustomerContact"
        v-if="customer.id"
      />

      <ul class="form-pagination">
        <li class="form-pagination__item form-pagination__item--active" />
        <li class="form-pagination__item" />
      </ul>
    </div>
  </div>
</template>

<script>
import api from '../api'

import Header from '../components/Header.vue';
import CustomerContact from '../components/CustomerContact.vue';

export default {
  name: 'VerifyCustomerContact',
  components: {
    Header, CustomerContact
  },
  methods: {
    verifyCustomerContact(contactAttributes, form) {
      const submitButton = form.elements.submit;

      submitButton.disabled = true;

      api.verifyCustomer(this.verificationToken, contactAttributes).then(customer => {
        this.customer = customer;
        this.$router.push(`/verify-customer-sizing/${this.verificationToken}`);
      }).catch(errors => {
        console.error(errors)
      }).finally(() => {
        submitButton.disabled = false
      })
    }
  },
  data() {
    return {
      verificationToken: this.$route.params.verification_token,
      customer: {}
    }
  },
  mounted() {
    api.getCustomerWithVerificationToken(this.verificationToken).then(customer => {
      this.customer = customer;
    });
  }
}
</script>
